import { IRootState } from '../../../store'
import { IHistoryState } from '../store/ccHpi.types'

export const getHistorySelector = (state: IRootState): IHistoryState => state.history
